import { Map } from 'immutable'
import { StopDescriptionActions } from '../constants/stopDescriptionConstants'

const INITIAL_STATE = Map({
    isOpen: false,
    mediaType: null,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case StopDescriptionActions.SET_IS_STOP_DESCRIPTION_OPEN:
            return state.set('isOpen', action.isOpen)
        case StopDescriptionActions.SET_SUPPLEMENTAL_MEDIA_TYPE:
            return state.set('mediaType', action.mediaType)
        default:
            return state
    }
}
